import AASALogo from "../Logos/AASA_logo.png";
import ConnecticutAPPSLogo from "../Logos/ConnecticutAPPS.png";
import GeorgiaSSALogo from "../Logos/GeorgiaSSA.png";
import MinnesotaASSPLogo from "../Logos/MinnesotaASSP.png";
import MinnesotaESPALogo from "../Logos/MinnesotaESPA.png";
import MASSPLogo from "../Logos/MississippiASSP.png";
import MOASSPLogo from "../Logos/MoASSP.png";
import NHASPLogo from "../Logos/NHASP.png";
import OASSALogo from "../Logos/OASSA.png";
import NWSClogo from "../Logos/NWSClogo.png";
import SAMLogo from "../Logos/SAM.jpg";
import NASALogo from "../Logos/NASALogo.png";
import MASALogo from "../Logos/MASALogo.png";
import Diaz from "../Logos/Diaz.jpeg";

export const ASSOCIATIONS = [
  {
    name: "New Hampshire Association of School Principals",
    abbreviation: "NHASP",
    slug: "new-hampshire-association-of-school-principals",
    website: "https://nhasp.style/",
    logo: NHASPLogo,
  },
  {
    name: "Mississippi Association of Secondary School Principals",
    abbreviation: "MASSP",
    slug: "mississippi-association-of-secondary-school-principals",
    website: "https://www.massp.net/",
    logo: MASSPLogo,
  },
  {
    name: "Missouri Association of Secondary School Principals",
    abbreviation: "MoASSP",
    slug: "missouri-association-of-secondary-school-principals",
    website: "https://www.moassp.com/",
    logo: MOASSPLogo,
  },
  {
    name: "Minnesota Association of Secondary School Principals",
    abbreviation: "MASSP",
    slug: "minnesota-association-of-secondary-school-principals",
    website: "",
    logo: MinnesotaASSPLogo,
  },
  {
    name: "Georgia School Superintendent Association",
    abbreviation: "GSSA",
    slug: "georgia-school-superintendent-association",
    website: "",
    logo: GeorgiaSSALogo,
  },
  {
    name: "Connecticut Association of Public School Superintendents",
    abbreviation: "CAPSS",
    slug: "connecticut-association-of-public-school-superintendents",
    website: "",
    logo: ConnecticutAPPSLogo,
  },
  {
    name: "School Administrators of Montana",
    abbreviation: "SAM",
    slug: "school-administrators-of-montana",
    website: "https://www.sammt.org/",
    logo: SAMLogo,
  },
  {
    name: "Ohio Association Of Secondary School Administrators",
    abbreviation: "OASSA",
    slug: "ohio-association-of-secondary-school-administrators",
    website: "https://www.oassa.org/",
    logo: OASSALogo,
  },
  {
    name: "Northwest Service Cooperative",
    abbreviation: "NWSC",
    slug: "northwest-service-cooperative",
    website: "https://www.nwservice.org/",
    logo: NWSClogo,
  },
  {
    name: "Nevada Association of School Administrators",
    abbreviation: "NASA",
    slug: "nevada-association-of-school-administrators",
    website: "https://www.nasanv.org/",
    logo: NASALogo,
  },
    {
    name: "Minnesota Association of School Administrators",
    abbreviation: "MASA",
    slug: "minnesota-association-of-school-administrators",
    website: "https://www.mnasa.org/",
    logo: MASALogo,
  },
   {
    name: "Dr. Raymond Diaz",
    abbreviation: "Dr. Diaz",
    slug: "dr-raymond-diaz",
    website: "https://gruvyeducation.com",
    logo: Diaz,
  },
];

const EXTRA_TRUST_LOGOS = [
  {
    id: "aasa",
    name: "AASA",
    logo: AASALogo,
  },
  {
    id: "minnesota-espa",
    name: "MinnesotaESPA",
    logo: MinnesotaESPALogo,
  },
  {
    id: "oassa",
    name: "OASSA",
    logo: OASSALogo,
  },
];

export const TRUST_LOGOS = [
  ...ASSOCIATIONS.map((association) => ({
    id: association.slug,
    name: association.name,
    logo: association.logo,
    website: association.website,
  })),
  ...EXTRA_TRUST_LOGOS,
];

const MAIN_LANDING_LOGOS = [
  {
    id: "new-hampshire-association-of-school-principals",
    name: "New Hampshire Association of School Principals",
    logo: NHASPLogo,
    website: "https://nhasp.style/",
  },
  {
    id: "minnesota-association-of-secondary-school-principals",
    name: "Minnesota Association of Secondary School Principals",
    logo: MinnesotaASSPLogo,
  },
  {
    id: "school-administrators-of-montana",
    name: "School Administrators of Montana",
    logo: SAMLogo,
    website: "https://www.sammt.org/",
  },
  {
    id: "oassa",
    name: "OASSA",
    logo: OASSALogo,
  },
  {
    id: "aasa",
    name: "AASA",
    logo: AASALogo,
  },
];

export const MAIN_LANDING_TRUST_LOGOS = MAIN_LANDING_LOGOS;
export const MAIN_LANDING_HERO_TRUST_LOGOS = MAIN_LANDING_LOGOS;

export const HERO_TRUST_LOGOS = [
  {
    id: "minnesota-assp",
    name: "MinnesotaASSP",
    logo: MinnesotaASSPLogo,
  },
  {
    id: "missouri-association-of-secondary-school-principals",
    name: "Missouri Association of Secondary School Principals",
    logo: MOASSPLogo,
    website: "https://www.moassp.com/",
  },
  {
    id: "oassa",
    name: "OASSA",
    logo: OASSALogo,
  },
  {
    id: "school-administrators-of-montana",
    name: "School Administrators of Montana",
    logo: SAMLogo,
    website: "https://www.sammt.org/",
  },
  {
    id: "new-hampshire-association-of-school-principals",
    name: "New Hampshire Association of School Principals",
    logo: NHASPLogo,
    website: "https://nhasp.style/",
  },
];

export const getAssociationBySlug = (slug) =>
  ASSOCIATIONS.find((association) => association.slug === slug) || null;
